export type CelebrationMissingFieldKey =
  | 'title'
  | 'start_date'
  | 'end_date'
  | 'location_name'
  | 'budget'
  | 'description';

type CelebrationFieldSource = {
  title?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  location_name?: string | null;
  budget?: number | null;
  description?: string | null;
};

const MISSING_FIELD_LABELS: Record<CelebrationMissingFieldKey, string> = {
  title: 'Celebration name',
  start_date: 'Start date',
  end_date: 'End date',
  location_name: 'Location',
  budget: 'Budget',
  description: 'Description',
};

const isBlank = (value: string | null | undefined): boolean => {
  return typeof value !== 'string' || value.trim().length === 0;
};

const isMissingBudget = (value: number | null | undefined): boolean => {
  return value === null || value === undefined || Number.isNaN(value);
};

export const getMissingCelebrationFields = (
  source: CelebrationFieldSource,
): CelebrationMissingFieldKey[] => {
  const missing: CelebrationMissingFieldKey[] = [];

  if (isBlank(source.title)) {
    missing.push('title');
  }
  if (isBlank(source.start_date)) {
    missing.push('start_date');
  }
  if (isBlank(source.end_date)) {
    missing.push('end_date');
  }
  if (isBlank(source.location_name)) {
    missing.push('location_name');
  }
  if (isMissingBudget(source.budget)) {
    missing.push('budget');
  }
  if (isBlank(source.description)) {
    missing.push('description');
  }

  return missing;
};

export const getMissingCelebrationFieldLabels = (
  source: CelebrationFieldSource,
): string[] => {
  return getMissingCelebrationFields(source).map((field) => MISSING_FIELD_LABELS[field]);
};
